export const ProductTimer = ({ 
    hit
}) => {

    const countDownTag = document.querySelector("body").dataset?.countdownTag;
    const countText = document.querySelector("body").dataset?.countdownText;
    const hasSoonTag = hit.tags.some((tag) => tag.toLowerCase() === 'soon');
    const hasCountdownTag = hit.tags.some((tag) => tag.toLowerCase() === countDownTag);

    return (
        <>
            {//hasSoonTag &&  
            hasCountdownTag && (
                <div className="productTimerContainer"></div>
            )}
        </>
    );
}